export default __webpack_public_path__ + "static/media/Letter W.d8ee6c38.mov";